import { createAsyncActions } from '~/utils/store';
import { BOARD_TYPES, BOARD_ID_MAP } from '../../constants';

export const SHOW = '@@DRAWER_MARKETING_BOARDS/SHOW';
export const CLOSE = '@@DRAWER_MARKETING_BOARDS/CLOSE';

export const CREATE = createAsyncActions('@@DRAWER_MARKETING_BOARDS/CREATE');
export const SAVE = createAsyncActions('@@DRAWER_MARKETING_BOARDS/SAVE');
export const DELETE = createAsyncActions('@@DRAWER_MARKETING_BOARDS/DELETE');

export const show = (data = null) => ({
    type: SHOW,
    payload: {
        data
    }
});

export const close = () => ({
    type: CLOSE,
    payload: {}
});

export const create = (data, boardType = BOARD_TYPES.MISSOES) => {
    const boardId = BOARD_ID_MAP[boardType];
    
    return {
        type: CREATE.INIT,
        payload: {
            request:{
                method: 'post',
                url: `/boards?board_id=${boardId}`,
                data,
                showLoading: false
            },
            boardType
        }
    };
};

export const save = (id, data, boardType = BOARD_TYPES.MISSOES) => {
    const boardId = BOARD_ID_MAP[boardType];
    
    return {
        type: SAVE.INIT,
        payload: {
            request:{
                method: 'post',
                url: `/boards/${id}?board_id=${boardId}`,
                data,
                showLoading: false
            },
            boardType
        }
    };
};

export const remove = (data, boardType = BOARD_TYPES.MISSOES) => {
    const boardId = BOARD_ID_MAP[boardType];
    
    return {
        type: DELETE.INIT,
        payload: {
            request:{
                method: 'delete',
                url: `/boards/${data.id}?board_id=${boardId}`,
            },
            data,
            boardType
        }
    };
};